module.exports = __webpack_public_path__ + "img/ic_empathy.dfedead9.png";